import React, { createContext, useState } from "react";

const SubStdSelContext = createContext();
let std=localStorage.getItem("stdSelection");
let sec=localStorage.getItem("secSelection");
let stdName=localStorage.getItem("stdSelectionName");
let secName=localStorage.getItem("secSelectionName");
const SubStdSelProvider = ({ children }) => {
  const [secSelectedOption, setSecSelectedOption] = useState(sec||"");
  const [stdSelectedOption, setStdSelectedOption] = useState(std||"");
  const [secSelectedOptionName, setSecSelectedOptionName] = useState(secName||"");
  const [stdSelectedOptionName, setStdSelectedOptionName] = useState(stdName||"");
  const [teacherDCM, setTeacherDCM] = useState("");
  const [event, setEvent] = useState(null);

  return (
    <SubStdSelContext.Provider
      value={{
        secSelectedOption,
        setSecSelectedOption,
        stdSelectedOption,
        setStdSelectedOption,
        event,
        setEvent,
        teacherDCM,
        setTeacherDCM,
        secSelectedOptionName,
        setSecSelectedOptionName,
        stdSelectedOptionName,
        setStdSelectedOptionName
      }}
    >
      {children}
    </SubStdSelContext.Provider>
  );
};

export { SubStdSelContext, SubStdSelProvider };
